import React, { useEffect, useRef } from "react";
import { DropdownContainer, DropdownMenu } from "./dropdown.styles";


interface DropdownProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  position?: 'left' | 'right';
  top?: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({ isOpen, onClose, children, position = 'right', top = false }) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    }

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose]);

  if (!isOpen) return <></>;

  return (
    <DropdownContainer ref={dropdownRef}>
      <DropdownMenu
        style={{
          ...(position === 'left' && {left: 0}),
          ...(position === 'right' && {right: 0}),
          ...(top ? {bottom: "calc(100% + 8px)"} : {top: "calc(100% + 8px)"})
        }}
        isVisible={isOpen}
      >
        {children}
      </DropdownMenu>
    </DropdownContainer>
  );
};

export default Dropdown;
